/* This is ment to build provide a quick starting point when starting new index type file */
import React from 'react';
import categoryScreenStyle from './style';

export default function CategoryScreen({titles, texts, BGImage}) {
	let style = categoryScreenStyle();

	return (
		<div style={style.outerStyle({BGImage: BGImage})}>
			<div style={style.floaterStyle()}>
				{titles ? (
					titles.map((title, i) => {
						return (
							<h1 key={i} style={style.titleStyle({isFirst: i === 0})}>
								{title}
							</h1>
						);
					})
				) : (
					<></>
				)}
				{texts ? (
					texts.map((text, i) => {
						return <p style={style.genericTextStyle()}>{text}</p>;
					})
				) : (
					<></>
				)}
			</div>
		</div>
	);
}
